import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

import { modelServices } from "../../scripts/ah.mb.ui.model-services";
import { ModelNotifier } from "../../scripts/model-notifier";

import { HandsontableRenderer } from "../../scripts/ah.mb.ui.HandsontableRenderer";
import { ClientNotifier, } from "../../scripts/ah.mb.client-notifications";

export interface ILinkDataModel {
    modelId: string;
    sourceNodePathAndName: string;
    destNodePathAndName: string;
}

@Component
export default class LinkDataDialog extends Vue {


    @Prop()
    value: ILinkDataModel;

    // Model change observer
    private modelObserver = new ModelNotifier();
    private modelServices = new modelServices(this.modelObserver);

    @Prop()
    variableTreeDivId: string;

    private tableRenderer: HandsontableRenderer;
//}

    mounted() {

    // Attach button handlers now, not in setup view, because that will cause multiple firing

        this.setupView(this.value.modelId, this.value);
        this.valueChanged();
    }

    @Watch("value", { deep: true})
    valueChanged() {

        if (this.value && this.value.modelId && this.value.sourceNodePathAndName
            && this.value.destNodePathAndName) {

            this.loadVariableValue(this.value);

        }
    }

    // Gets variable value from server and displays it
    private loadVariableValue(value: ILinkDataModel) {

        this.modelServices.getLinkData(value.modelId, value.sourceNodePathAndName,
            value.destNodePathAndName,
            this.nodeDataReceivedFunc);
    };

    // Node data received handler
    private nodeDataReceivedFunc(data) {


        var container: any = $("#linkDataTableDiv");

        // This returns an array of NodeDataRecord
        // For now we will just show the first record
        if (data.length > 0) {
 
            this.tableRenderer.drawTable($("#linkDataTableDiv"), data, "Link Data");

        };
    }


    /**
     * Sets up the dialog
     */
    setupView (modelId: string, value: ILinkDataModel) {

        //this.pendingChanges = false;

        // Create the table with no data
        var options: Handsontable.Options =
        {
            data: [],
            contextMenu: true,

            //beforeChange: () => this.setPendingChanges(true),

            afterChange:
                (changes, source) => {
                    // After change handler    
                },
            stretchH: "all",
            copyPaste: true,
            minSpareRows: 0
        }

        this.tableRenderer = new HandsontableRenderer(options);

        // Get the node variables
        //this.getNodeVariables(modelId, nodePathAndName);

    }



    closeButtonClick() {
        this.$emit("dialogClosed");

    }

}



// WEBPACK FOOTER //
// ./ClientApp/components/link-data-dialog/link-data-dialog.ts